import { useMemo } from 'react'
import { useRouteError } from 'react-router-dom'

import * as Box from '~/components/Box.tsx'
import { Button } from '~/components/Button.tsx'

import sadBotty from './sad-botty.svg'
import errorPageStyles from '../ErrorPage.module.scss'
import IntercomLink from '../IntercomLink.tsx'

export const ErrorBox = () => {
  const error = useRouteError()

  const errorMessage = useMemo(() => {
    if (typeof error === 'string') {
      return error
    }

    if (error instanceof Error) {
      return error.message
    }

    return undefined
  }, [error])

  return (
    <Box.Outer>
      <Box.Content>
        <Box.Section>
          <div className={errorPageStyles.wrapper}>
            <img className={errorPageStyles.icon} src={sadBotty} alt="Sad Botty" />
            <div className={errorPageStyles.inner}>
              <h3>Error</h3>

              <div className={errorPageStyles.errorText}>
                <p>
                  There was a problem with processing your request. Please try again. If the error
                  persists, contact us.
                </p>
              </div>

              <ul className="ul ul--compact">
                <li className="ul__item">
                  <Button
                    variant="inline-link"
                    onClick={() => window.location.reload()}
                    style={{ paddingInline: '0' }}
                  >
                    Reload page
                  </Button>
                </li>
                <li className="ul__item">
                  <IntercomLink message="Hey, I found an error on your website">
                    Contact support
                  </IntercomLink>
                </li>
              </ul>

              {errorMessage && (
                <div className={errorPageStyles.errorDetails}>
                  <hr className="hr hr--compact" />
                  <code className={errorPageStyles.errorMessage}>{errorMessage}</code>
                </div>
              )}
            </div>
          </div>
        </Box.Section>
      </Box.Content>
    </Box.Outer>
  )
}

export const MainError = () => (
  <main>
    <ErrorBox />
  </main>
)

export const LayoutError = () => (
  <main className="tl-container" style={{ marginTop: 40 }}>
    <ErrorBox />
  </main>
)
